import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

const LandingPage = () => {
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);

  const handleStartClick = () => {
    navigate("/location");
  };

  const toggleReadMore = () => {
    setShowMore((prev) => !prev);
  };

  return (
    <div className="landing-page">
      <Header />
      <div className="landing-content">
        <h1>Persona Creator</h1>
        <h3>
          Ensuring digital protection and representation for minority ethnic
          communities
        </h3>
        <div className="intro-text">
          <p>
            The PersonaCreator app is part of the{" "}
            <a
              href="https://www.primecommunities.online/"
              target="_blank"
              rel="noopener noreferrer"
            >
              PRIME (Protecting Minority Ethnic Communities Online)
            </a>{" "}
            project. It uses machine learning techniques on data collected in
            PRIME's own survey as well as data from other public surveys, to
            create persona of people from Minority Ethnic Communities. These
            personas depict how people from these communities feel or experience
            various online harms, discrimination and bias while using digital
            services related to Health, Energy and Social Housing.
          </p>
          {!showMore ? (
            <button
              id="showMoreButton"
              className="link-button"
              onClick={toggleReadMore}
            >
              Show More
            </button>
          ) : (
            <>
              <p>
                PersonaCreator has been developed with the aim to provide
                various stakeholders of digital services related to Health,
                Energy and Social Housing, to better understand the needs and
                concerns of different minority ethnic groups as well as hidden
                sub-groups within broad ethnic groups in England and Scotland.
              </p>
              <p>
                With PersonaCreator, you will be able to select which surveys
                you want to use to create such personas. Specify which ethnic
                groups and nations you want these personas to belong to and
                which specific topics you want to focus on. The created personas
                can be also downloaded in various formats for later reflection
                and discussion.
              </p>
              <button
                id="showLessButton"
                className="link-button"
                onClick={toggleReadMore}
              >
                Show Less
              </button>
            </>
          )}
          <button
            id="startButton"
            className="start-button"
            onClick={handleStartClick}
          >
            Start Creating Personas!
          </button>
          <button
            id="startButton"
            className="start-button"
            onClick={() => navigate("/upload")}
          >
            Upload your own data
          </button>
          ----------------------------------------------------------------------------------------------------------------------------------------------------------
          <p>
            This work was done under the UKRI-funded (EP/W03235X/1,
            EP/W032333/1, EP/W032341/1, EP/ W032058/1, EP/W032082/1) project
            called PRIME (Protecting Minority Ethnic Communities Online). For
            more information, comments or suggestions , please contact Mehdi
            Rizvi (s.rizvi@hw.ac.uk) or Lynne Baillie (l.baillie@hw.ac.uk){" "}
            <br></br>
            <br></br>
            The citation for this work is: Rizvi, M., Baillie, L., Pang, W.,
            Shahandashti, S., Yuan, Y., Ghosh, S., Lewinska, P., Chen, K.,
            Edmondson, A., Anil Kumar, A. S., Jagadeesan, V. B., Jacob, F., &
            Dodd, C. (2025). ”Carefully Connected - Towards Designing More
            Equitable Digital Services”,{" "}
            <a
              href="https://doi.org/10.17861/C1DX-PQ86"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://doi.org/10.17861/C1DX-PQ86
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
